import {
	DISH_DESCRIPTION_MAX_LENGTH,
	DISH_TAG_LABELS,
	DISH_TAGS,
	DISH_TITLE_MAX_LENGTH,
} from "../constants";

/**
 * @param {unknown} key
 * @returns {key is string}
 */
export function isDishTag(key) {
	return typeof key === "string" && DISH_TAGS.includes(key);
}

/**
 * @param {unknown} key
 * @returns {string}
 */
export function dishTagLabel(key) {
	if (key == null || key === "") {
		return "";
	}
	const k = String(key);
	if (isDishTag(k)) {
		return DISH_TAG_LABELS[k];
	}
	return k;
}

/**
 * Dropdown rows for tags not yet selected (`{ head, value }[]` for Generic Dropdown).
 * @param {unknown} selectedKeys
 * @returns {{ head: string, value: string }[]}
 */
export function buildDishTagDropdownOptions(selectedKeys) {
	const selected = new Set(Array.isArray(selectedKeys) ? selectedKeys.filter(isDishTag) : []);
	return DISH_TAGS.filter((k) => !selected.has(k)).map((value) => ({
		head: dishTagLabel(value),
		value,
	}));
}

/**
 * Unique known tag keys from an API tag array.
 * @param {unknown} tags
 * @returns {string[]}
 */
export function dishTagKeysFromApi(tags) {
	if (!Array.isArray(tags)) {
		return [];
	}
	const seen = new Set();
	const out = [];
	for (const item of tags) {
		if (item && isDishTag(item) && !seen.has(item)) {
			seen.add(item);
			out.push(item);
		}
	}
	return out;
}

/**
 * Shared form validation for create/edit dish pages.
 * @param {{
 *   title?: string;
 *   description?: string;
 *   notes?: string;
 *   imageUrl?: string;
 *   tags?: unknown[];
 * }} fields
 * @returns {void}
 */
export function validateDishForm(fields) {
	const titleTrimmed = fields?.title?.trim();
	if (!titleTrimmed) {
		throw new Error("Title is required");
	}
	if (titleTrimmed.length > DISH_TITLE_MAX_LENGTH) {
		throw new Error(`Title must be at most ${DISH_TITLE_MAX_LENGTH} characters`);
	}
	const descriptionTrimmed = fields?.description?.trim();
	if (!descriptionTrimmed) {
		throw new Error("Description is required");
	}
	if (descriptionTrimmed.length > DISH_DESCRIPTION_MAX_LENGTH) {
		throw new Error(`Description must be at most ${DISH_DESCRIPTION_MAX_LENGTH} characters`);
	}
	if (!fields?.notes?.trim()) {
		throw new Error("Notes is required");
	}
	if (!fields?.imageUrl?.trim()) {
		throw new Error("Image URL is required");
	}
	const tags = Array.isArray(fields?.tags) ? fields.tags : [];
	if (!tags.length) {
		throw new Error("At least one tag is required");
	}
}
